<h2 mat-dialog-title class="detail-dialog-title">
  <span class="title-main">{{ ticket.subject }}</span>
  <button
    mat-icon-button
    type="button"
    (click)="close()"
    [attr.aria-label]="'supportTickets.closeAria' | translate"
  >
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="detail-dialog-content">
  <p class="detail-id muted">{{ ticket._id }}</p>
  <p class="detail-status-line">
    <span class="detail-label">{{ 'supportTickets.statusLabel' | translate }}</span>
    <span class="ticket-status-pill" [attr.data-status]="ticket.status">{{
      statusLabel(ticket.status)
    }}</span>
  </p>

  <div class="detail-label">{{ 'supportTickets.yourMessage' | translate }}</div>
  <div class="detail-body">{{ ticket.description }}</div>

  <div class="detail-label conversation-title">
    {{ 'supportTickets.conversation' | translate }}
  </div>
  <div *ngIf="messagesLoading" class="thread-loading">
    {{ 'supportTickets.messagesLoading' | translate }}
  </div>
  <div class="message-thread" *ngIf="!messagesLoading">
    <div
      *ngFor="let m of messageThread"
      class="message-row"
      [class.from-user]="m.author === 'user'"
      [class.from-admin]="m.author === 'admin'"
    >
      <div class="message-meta">
        <span class="message-who">{{ messageAuthorLabel(m) }}</span>
        <span *ngIf="m.isClarificationRequest" class="clarification-pill">{{
          'supportTickets.clarificationRequest' | translate
        }}</span>
        <span class="message-date">{{ formatDate(m.createdAt) }}</span>
      </div>
      <div class="message-body">{{ m.body }}</div>
    </div>
    <div *ngIf="messageThread.length === 0" class="thread-empty">
      {{ 'supportTickets.noMessagesYet' | translate }}
    </div>
  </div>

  <div
    class="reporter-status-actions"
    *ngIf="!messagesLoading && (canMarkResolved() || canReopenTicket())"
  >
    <button
      *ngIf="canMarkResolved()"
      type="button"
      class="secondary-action-btn"
      (click)="markTicketResolved()"
      [disabled]="statusActionLoading"
    >
      {{ 'supportTickets.markResolved' | translate }}
    </button>
    <button
      *ngIf="canReopenTicket()"
      type="button"
      class="secondary-action-btn"
      (click)="reopenTicket()"
      [disabled]="statusActionLoading"
    >
      {{ 'supportTickets.reopenTicket' | translate }}
    </button>
  </div>

  <div class="user-reply">
    <label class="detail-label">{{
      'supportTickets.addComment' | translate
    }}</label>
    <textarea
      class="comment-input"
      rows="3"
      [(ngModel)]="newCommentBody"
      [placeholder]="'supportTickets.commentPlaceholder' | translate"
    ></textarea>
    <button
      type="button"
      class="nx-c4g-support-ticket-add-btn send-comment-btn"
      (click)="submitComment()"
      [disabled]="postingComment || !newCommentBody.trim()"
    >
      {{ 'supportTickets.sendComment' | translate }}
    </button>
  </div>
</mat-dialog-content>
